var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoadsNumberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 7.45005L0.575 0.550049H10.925V4.00005H10.35C10.35 3.23338 10.005 1.70005 8.625 1.70005H4.025L8.05 6.87505L3.45 12.05H9.2C10.925 12.05 11.5 10.325 11.5 10.325H12.075L11.5 14.35H0L5.75 7.45005ZM3.45156 15.5H5.75078H8.05156H12.6516H13.8008H13.8016V9.75005H17.2516L18.4016 15.5H23.0016V18.9501H20.7016V17.8H5.75156V18.9501H3.45156V15.5ZM5.75156 27L7.36156 18.9501H12.6516V27H5.75156ZM13.8016 27V18.9501H19.0916L20.7016 27H13.8016Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadsNumberIcon);
export default __webpack_public_path__ + "static/media/roadsNumberIcon.28911748847b1616bd33f404bf555296.svg";
export { ForwardRef as ReactComponent };